import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { FileUp, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaAnexoAdicionado = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('adicionou anexo');
};

const getIconAnexoAdicionado = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: FileUp, color: 'var(--c41c49f)' };
};

export default function CardAnexoAdicionado({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconAnexoAdicionado(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const anexoAdicionadoConfig = {
    tipo: 'anexo_adicionado',
    detectaTipo: detectaAnexoAdicionado,
    getIcon: getIconAnexoAdicionado,
    temExpansao: () => true,
    Component: CardAnexoAdicionado
};

